import type { EnemyConfig } from '../../entities/EnemyConfig';

export const WOLF_CONFIG: EnemyConfig = {
  id: 'wolf',
  displayName: 'Волк',
  maxHp: 3,
  speed: 100,
  movementBehavior: 'wolf',
  movementParams: {
    speedMultiplier: 1.35,
    diagonalAngleDeg: 35,
  },
  size: 31,
  color: 0x4a4a52,
  scoreReward: 14,
};
